// Angular
import { Component, inject } from '@angular/core';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

const PRIME_MODULES = [ButtonModule];

@Component({
  selector: 'app-sms-modal',
  standalone: true,
  imports: [PRIME_MODULES],
  templateUrl: './reload-modal.component.html',
  styleUrl: './reload-modal.component.scss',
})
export class ReloadModalComponent {
  private ref = inject(DynamicDialogRef);

  constructor() {}

  closeModal() {
    this.ref.close();
  }
}
